// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"4c7d564c","130":"334c13a9","274":"4c7d564c","461":"889c8f73","684":"24bb9ebe","714":"24bb9ebe","838":"334c13a9","915":"889c8f73"}[chunkId] + ".chunk.css";
};